// REST already treats VITE_API_BASE_URL as the canonical override. The socket
// must derive from that same origin: using only VITE_BACKEND_URL lets a local
// API run on one port while every Case Discovery socket quietly opens another.
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_BACKEND_URL || '';

function getWsUrl(baseUrl: string): string {
  return baseUrl.replace(/^http/, 'ws').replace(/\/api\/?$/, '');
}

export const WS_AGENT_URL = `${getWsUrl(API_BASE_URL)}/api/case-discovery-v3/ws`;

/**
 * Le backend laisse 800 s à la compaction entière (repli vers un autre fournisseur
 * compris, depuis le 2026-10-12), puis une minute couvre la persistance et le
 * verdict. Ce délai doit rester AU-DESSUS du budget backend : plus court, le client
 * annoncerait « ne répond pas » pendant qu'un résumé valide est encore en route.
 * Un timeout client ne prouve pas que le serveur a terminé.
 * Source interne : lib/llm/context/ContextCompactor.ts, COMPACTION_TIMEOUT_MS.
 */
export const COMPACTION_CLIENT_TIMEOUT_MS = 800_000 + 60_000;

export const WS_RECONNECT_CONFIG = {
  maxAttempts: 5,
  baseDelay: 1000,
  maxDelay: 30000,
} as const;
